<template>
  <div
    class="banner-carousel"
    :class="{ 'banner-carousel-round-effect': isSwiperReady }"
  >
    <div class="carousel-wrap">
      <div v-if="multi" class="arrow">
        <img
          @click="moveSwiper(1)"
          src="@/assets/img/icon/ico-banner-arrow-l.svg"
        />
      </div>
      <swiper
        ref="mySwiper"
        :options="swiperOption"
        :auto-update="true"
        :auto-destroy="true"
        :delete-instance-on-destroy="true"
        :cleanup-styles-on-destroy="true"
        @ready="handleSwiperReadied"
      >
        <swiper-slide
          v-for="(banner, index) in banners"
          :key="banner.link"
          :class="'swiper-slide' + (index + 1)"
        >
          <div @click="toCuration(banner)" class="page">
            <img onerror="this.classList.add('error-img')" :src="banner.img" />
            <img class="error-holder" src="@/assets/img/placholder_1200.svg" />
          </div>
        </swiper-slide>
      </swiper>
      <div v-if="multi" @click="moveSwiper(0)" class="arrow r">
        <img src="@/assets/img/icon/ico-banner-arrow-r.svg" />
      </div>
      <div @click="toggleList" class="all-banner">
        全部
        <span class="down">
          <img src="@/assets/img/arrow-down.svg" />
        </span>
      </div>
    </div>
    <div class="banner-list" :class="{ expand: isExpand }">
      <div
        v-for="(banner, index) in banners"
        :key="index"
        @click="toCuration(banner)"
        class="banner"
      >
        <img onerror="this.classList.add('error-img')" :src="banner.img" />
        <img class="error-holder" src="@/assets/img/placholder_1200.svg" />
      </div>
      <div class="back">
        <v-btn class="v-btn-primary" color="primary" @click="toggleList">
          返回
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'carrousel',
  props: {
    banners: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    multi() {
      return this.banners.length > 1
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        initialSlide: 0,
        spaceBetween: 0,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        loop: true,
        followFinger: false,
        observer: true,
        observeParents: true,
      },
      isSwiperReady: false,
      isExpand: false,
    }
  },
  methods: {
    toggleList() {
      this.isExpand = !this.isExpand
      this.$emit('onExpand', this.isExpand)
    },
    moveSwiper(prev) {
      if (prev) {
        this.$refs.mySwiper.swiper.slidePrev()
      } else {
        this.$refs.mySwiper.swiper.slideNext()
      }
    },
    toList() {
      this.$router.push({ name: 'bannerList' })
    },
    toCuration(banner) {
      gtag('event', 'click', {
        event_id: '001',
        location: '首頁',
        event_category: '輪播banner',
        event_label: banner.title,
        value: 1,
      })
      this.$router.push({ name: 'curation', params: { id: banner.link } })
    },
    handleSwiperReadied() {
      this.isSwiperReady = true
    },
  },
}
</script>

<style lang="scss" scoped>
.banner-carousel {
  z-index: 0;
  .carousel-wrap {
    position: relative;
  }
  * {
    user-select: auto;
    -webkit-touch-callout: auto;
    touch-action: auto;
  }
  .swiper-container {
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;
    font-size: 0;
  }
  .arrow {
    position: absolute;
    padding: 24% 4px;
    height: 100%;
    width: 9.6%;
    z-index: 5;
    top: 0;
    border-radius: 16px 0 0 16px;
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );
    &.r {
      right: 0;
      border-radius: 0 16px 16px 0;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.2) 100%
      );
    }
    img {
      width: 100%;
    }
  }
}
.page {
  width: 100%;
  a {
    display: block;
    min-height: 177px;
    background: url('../../assets/img/placholder_1200.svg');
    background-size: contain;
    background-repeat: no-repeat;
  }
  img {
    width: 100%;
    min-height: 177px;
    &.error-img {
      display: none;
      & + .error-holder {
        display: block;
      }
    }
  }
  .error-holder {
    display: none;
  }
}
.all-banner {
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 6;
  right: 6px;
  bottom: 10px;
  opacity: 0.6;
  font-size: 12px;
  color: #545454;
  height: 18px;
  background-color: #f9fafb;
  border-radius: 12px;
  text-align: center;
  padding-left: 8px;
  padding-right: 4px;
  word-break: keep-all;
  white-space: nowrap;

  .down {
    display: inline-block;
    width: 11px;
    white-space: nowrap;
    font-size: 0;
    img {
      width: 100%;
    }
  }
}
.banner-list {
  display: none;

  &.expand {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    overflow-y: scroll;
    display: block;
    padding: 0px 4.8% 20px;
    background-color: rgba($color: #545454, $alpha: 0.65);
  }
  .banner {
    min-height: 150px;
    border-radius: 16px;
    overflow: hidden;
    font-size: 0;
    margin-top: 20px;
    background-color: #f3f5f8;
    img {
      width: 100%;
      &.error-img {
        display: none;
        & + .error-holder {
          display: block;
        }
      }
    }
    .error-holder {
      display: none;
    }
  }
  .back {
    padding-top: 20px;
  }
}
.useMock .banner-list {
  padding-top: 75px;
}
</style>
